import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export type FolderAssetSortDirection = "asc" | "desc" | "none";

interface EmitOptions {
  sortDirection: FolderAssetSortDirection;
  assetCount: number;
  folderId?: string;
}

export function useEmitFolderAssetSortEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({ sortDirection, assetCount, folderId }: EmitOptions) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.FolderAssetSort,
        optionSelected: sortDirection,
        systemName: SERVICE_NAME,
        customTrackingFields: {
          asset_count: assetCount,
          folder_id: folderId,
        },
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
